/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

import '../assets/css/style.css'
import yokin from '../assets/img/shisan/image_1.svg'
import kakaku from '../assets/img/shisan/image_2.svg'
import dummy from '../assets/img/shisan/image_3.svg'
import zinko from '../assets/img/shisan/image_4.svg'
import titleShisan from '../assets/img/title/title_shisan.svg'
import { Link } from 'react-router-dom'
import { Header } from '../components/header'
import { Footer } from '../components/footer'
import { useHeadTitle } from '../hook/useHeadTitle'
import { useDealerCodeUrl } from '../hook/useDealerCode'
import { useDescription } from '../hook/useDescription'

export default function Shisan() {
  useHeadTitle('今こそ資産運用を考えよう', '資産運用')
  useDescription(
    '資産運用について知っておきたい基本とコツ。野村アセットマネジメントが資産運用に取り組む皆さまをサポートします。'
  )

  return (
    <React.Fragment>
      <Header />
      <main>
        <section>
          <div className="c-title-wrap">
            <h2 className="c-title--primary">
              <span className="c-title__balloon">
                <span>低金利がつづく今だから</span>
              </span>
              <img src={titleShisan} alt="資産運用" />
            </h2>
            <p className="c-title__lead">
              1990年ごろまでは、金利は高い水準にありましたが、現在は低い水準が続いています。
            </p>
          </div>
          <div className="l-container">
            <div className="u-pt27px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">あなたの資産、預金のままで大丈夫？</span>
                </h3>
                <div className="p-shisan__box-body">
                  <p className="u-text--center">
                    <img src={yokin} alt="100万円預けた場合のグラフ" />
                  </p>
                  <div>
                    <p className="c-note u-mt10px">
                      （出所）日本銀行のデータに基づき野村アセットマネジメント作成
                    </p>
                    <p className="c-note">
                      ※各年の最終週時点
                      <br />
                      上記は金利と利息のイメージを表すものであり、実際に貯蓄した場合の効果を示すものではありません。
                    </p>
                  </div>
                </div>
              </section>
            </div>

            <div className="u-pt80px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">
                    長期的にはモノ・サービスの価格は上昇しました
                  </span>
                </h3>
                <div className="p-shisan__box-body">
                  <p className="u-text--center">
                    <img src={kakaku} alt="モノ・サービスの価格の変化例" />
                  </p>
                  <div>
                    <p className="c-note u-mt6px">
                      （出所）「小売物価統計調査（動向編）調査結果」（総務省統計局）（
                      <a href="https://www.stat.go.jp/" target="_blank" rel="noopener noreferrer">
                        https://www.stat.go.jp/
                      </a>
                      ）に基づき野村アセットマネジメント作成
                    </p>
                  </div>
                </div>
              </section>
            </div>

            <div className="u-pt80px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">日本では少子高齢化が進んでいます</span>
                </h3>
                <div className="p-shisan__box-body">
                  <p className="p-shisan__lead">
                    {/* eslint-disable-next-line max-len */}
                    日本では少子高齢化が進んでおり、引退した世代の人口が増える一方で、現役世代の人口が減っています。この状況が続けば、公的年金制度に大きな影響を与えると考えられます。
                  </p>
                  <p className="u-text--center u-mt57px">
                    <img src={dummy} alt="年齢別人口構成の推移" />
                  </p>
                  <p className="c-note u-mt20px">
                    （注）現役世代は15歳～64歳、年金世代は65歳以上の人口、現役世代÷年金世代
                    <br />
                    （出所）総務省「国勢調査『人口推計（各年10月1日現在）』」（
                    <a href="https://www.stat.go.jp/" target="_blank" rel="noopener noreferrer">
                      https://www.stat.go.jp/
                    </a>
                    ）、国立社会保障・人口問題研究所「日本の将来推計人口（2023年4月）」（出生中位・死亡中位推計）（
                    <a href="http://www.ipss.go.jp/" target="_blank" rel="noopener noreferrer">
                      http://www.ipss.go.jp/
                    </a>
                    ）を基に野村アセットマネジメント作成
                  </p>
                </div>
              </section>
            </div>

            <div className="u-pt80px">
              <section className="c-box">
                <h3 className="c-box__head">
                  <span className="c-box__head__title">
                    世界の経済成長を取り込むために資産運用を考えてみませんか？
                  </span>
                </h3>
                <div className="p-shisan__box-body">
                  <p className="p-shisan__lead">
                    {/* eslint-disable-next-line max-len */}
                    世界の経済規模は人口増加や技術革新などを背景に拡大してきました。様々な資産に投資することで、誰でも世界の経済成長の恩恵を受けることができます。これからの人生設計とともに資産運用を考えてみませんか。
                  </p>
                  <p className="u-text--center u-mt45px">
                    <img src={zinko} alt="世界人口グラフ" />
                  </p>
                  <p className="c-note">
                    経済規模は名目GDP（国内総生産）、2040年はIMF予想。先進国および新興国はIMFの定義による。
                  </p>
                  <p className="c-note u-mt20px">
                    （出所）国連、IMF、Factset等のデータに基づき野村アセットマネジメント作成
                    <br />
                    上記は過去のデータであり、将来の投資成果を示唆あるいは保証するものではありません。
                  </p>
                </div>
              </section>
            </div>
          </div>
        </section>

        <div className="u-bg--white u-mt60px">
          <div className="c-button-group">
            <Link to={useDealerCodeUrl('/')} className="c-button--primary c-button-arrow--back">
              <span className="c-button__text--xs">TOPページへ戻る</span>
            </Link>
            <Link
              to={useDealerCodeUrl('/rougo')}
              className="c-button--primary c-button-arrow--next"
            >
              <span className="c-button__text--xs u-mr10px">老後資金へ進む</span>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}
